/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import {
  ResponsiveSelect,
  ResponsiveSelectContent,
  ResponsiveSelectTrigger,
  ResponsiveSelectItem,
} from "@/components/molecules/responsive-select";
import { languages, useLanguage } from "@/features/utils/i18n";
import { useTheme } from "@/features/utils/theme";
import { MoonIcon, SunIcon } from "@phosphor-icons/react";
import { FlagComponent } from "../phone";
import { useTranslation } from "@/features/utils/i18n";

const languageToCountryCode: any = {
  FR: "FR",
  EN: "GB",
};

export const ThemeAndLanguageSwitcher = () => {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();
  const { currentLanguage: lang, changeLanguage } = useLanguage();

  const themeLocked = document.location.search.includes("theme");

  return (
    <div className="flex items-start gap-1">
      {!themeLocked && (
        <Button
          tooltip={t("common.toggleTheme")}
          className="overflow-hidden relative h-7! w-7!"
          variant="outline"
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
        >
          <MoonIcon
            style={{
              transform:
                theme === "dark"
                  ? "rotate(0deg) translate(0, 0)"
                  : "rotate(60deg) translate(30px, 0)",
              opacity: theme === "dark" ? 1 : 0.5,
              transition: "all 0.5s ease-in-out",
            }}
          />
          <SunIcon
            className="absolute"
            style={{
              transform:
                theme === "dark"
                  ? "rotate(-60deg) translate(-30px, 0)"
                  : "rotate(0deg) translate(0, 0)",
              opacity: theme === "dark" ? 0.5 : 1,
              transition: "all 0.5s ease-in-out",
            }}
          />
        </Button>
      )}
      <ResponsiveSelect>
        <ResponsiveSelectTrigger
          className="w-14 h-7! pl-1.5! pr-1!"
          tooltip={t("common.changeLanguage")}
        >
          <FlagComponent
            country={languageToCountryCode[lang]}
            countryName={languages[lang]}
          />
        </ResponsiveSelectTrigger>
        <ResponsiveSelectContent className="w-max">
          {Object.keys(languages).map((lang) => (
            <ResponsiveSelectItem
              value={lang}
              key={lang}
              onSelect={() => changeLanguage(lang)}
            >
              <div className="flex items-center gap-2">
                <FlagComponent
                  country={
                    languageToCountryCode[lang as keyof typeof languages]
                  }
                  countryName={languages[lang as keyof typeof languages]}
                />
                <span>{languages[lang as keyof typeof languages]}</span>
              </div>
            </ResponsiveSelectItem>
          ))}
        </ResponsiveSelectContent>
      </ResponsiveSelect>
    </div>
  );
};
